$(function() {

    var elems = $('.switchery').toArray();

    elems.forEach(function(elem) {
        var switcher = new Switchery(elem);
    });

});
